import { MicrosoftOfficeOperationProtectionContextBaseModel } from '../microsoft/microsoft-office-operation-protection-context-base-model';

export class MicrosoftOfficeOperationProtectionContextModel extends MicrosoftOfficeOperationProtectionContextBaseModel {
  learningDuration: number|null;
  providerPolicy: string;
  countries: string[];
  orgUnitEndLearningId: string|null;
}
